export function GetEndPointSP(id: number): string {
  return `stack2/${id}`;
}
